<template>
	<v-list-item :href="'#' + tab.html" @click="selectTab(tab)" :class="{ 'v-list-item--active': isTabSelected, 'primary--text': isTabSelected }" color="primary">
		<v-list-item-icon><v-icon>{{ tab.icon }}</v-icon></v-list-item-icon>
		{{ tabDisplay }}
		<a class="ui label" :class="noticeColor" v-if="tab.notice" style="position: absolute; right: 0.5em" ref="notice">{{ tab.notice.display }}</a>
	</v-list-item>
</template>

<script>
export default {
	props: {
		tab: {
			default: {}
		},
		isTabSelected: {
			default: false
		}
	},
	computed: {
		tabDisplay: function() {
			if(window.i18n && this.tab.name) {
				var name = 'tabs.' + this.tab.name.toCamelCase();
				var label = window.i18n.t(name);
				if(name !== label) {
					return label;
				}
			}

			return this.tab.name;
		},
		noticeColor: function() {
			if(this.tab.notice && this.tab.notice.color) {
				return this.tab.notice.color;
			} else {
				return 'orange';
			}
		}
	},
	methods: {
		selectTab: function(tab) {
			this.$emit('selectTab', tab);
		}
	},
	updated: function() {
		if(this.$refs.notice) {
			if($(this.$refs.notice).hasClass('has-popup')) {
				$(this.$refs.notice).removeClass('has-popup').dropdown('destroy');
			}

			if(this.tab.notice.popup) {
				$(this.$refs.notice).popup({
					content: this.tab.notice.popup
				}).addClass('has-popup');
			}
		}
	}
};
</script>

<style scoped>

</style>